import React, { JSX } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import * as Types from 'types/types';

export function JobDetails(props: { activeJob: Types.Job; job: Types.Job }): JSX.Element {
  const { activeJob, job } = props;

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Chip
          label={job.details?.isActive ? 'Active' : 'Inactive'}
          color={job.details?.isActive ? 'success' : 'default'}
          size="small"
          sx={{ mr: 1 }}
        />
        {job.details?.employmentType && (
          <Chip label={job.details.employmentType} variant="outlined" size="small" sx={{ mr: 1 }} />
        )}
      </Box>
      {activeJob.details?.location && (
        <Typography variant="body2" color="text.secondary" gutterBottom>
          📍 {activeJob.details.location.city},{' '}
          {activeJob.details.location.state || activeJob.details.location.country}
        </Typography>
      )}
      {activeJob.owner && (
        <Typography variant="body2">
          <strong>Submitted by:</strong> {activeJob.owner.fullName}
        </Typography>
      )}
      {activeJob.createdAt && (
        <Typography variant="caption">Created: {activeJob.createdAt.toISOString()}</Typography>
      )}
      {activeJob.updatedAt && (
        <Typography variant="caption">Updated: {activeJob.updatedAt.toISOString()}</Typography>
      )}
      <Typography variant="caption">Job ID: {job.id}</Typography>
    </>
  );
}
